export const versoFetchOptionsOverride = options => {
  const token = localStorage.getItem('Meteor.loginToken');
  options.url = process.env.GRAPHQL_URL || 'http://localhost:3000/graphql';
  if (token) {
    options.headers.authorization = token;
  }
};
